import { selector, useRecoilValueLoadable } from "recoil";

import { BalanceSelectedEndingMonth, BalanceSelectedStartingMonth, SelectedPropertyIds } from "@/view_models/atoms";
import { MonthlyBalanceSheetsForBalance } from "@/view_models/balancesheetSelectors";
import { OwnedPropertiesWithSample } from "@/view_models/propertySelectors";

import { buildBalanceSummary, PropertyMonthMaps } from "../utils/balanceSummary";

const BalanceSummaryState = selector({
  key: "ds_v2_balance_summary",
  get: ({ get }) => {
    const properties = get(OwnedPropertiesWithSample);
    const maps: PropertyMonthMaps = new Map();
    properties.forEach((holder) => maps.set(holder.id, get(MonthlyBalanceSheetsForBalance(holder.id))));
    return buildBalanceSummary(
      properties,
      get(SelectedPropertyIds),
      maps,
      get(BalanceSelectedStartingMonth),
      get(BalanceSelectedEndingMonth)
    );
  },
});
export const useBalanceSummary = () => {
  const loadable = useRecoilValueLoadable(BalanceSummaryState);
  return {
    loading: loadable.state === "loading",
    error: loadable.state === "hasError",
    data: loadable.state === "hasValue" ? loadable.contents : null,
  };
};
